import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className="flex items-center gap-2 no-underline group"
        >
          <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-950">
            <i className="ri-spy-line text-xl text-background-50"></i>
          </div>
          <span className={`text-xl font-bold whitespace-nowrap transition-colors duration-300 font-sans ${
            isScrolled ? 'text-foreground-950' : 'text-white'
          }`}>
            黑料在线
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-foreground-950/10 ${
              location.pathname === '/'
                ? isScrolled ? 'text-foreground-950 bg-foreground-950/10' : 'text-white bg-white/20'
                : isScrolled ? 'text-foreground-700' : 'text-white/80'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-foreground-950/10 ${
                location.pathname === `/category/${cat.slug}`
                  ? isScrolled ? 'text-foreground-950 bg-foreground-950/10' : 'text-white bg-white/20'
                  : isScrolled ? 'text-foreground-700' : 'text-white/80'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-200 hover:bg-foreground-950/10 ${
              location.pathname === '/about'
                ? isScrolled ? 'text-foreground-950 bg-foreground-950/10' : 'text-white bg-white/20'
                : isScrolled ? 'text-foreground-700' : 'text-white/80'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
            isScrolled ? 'text-foreground-950 hover:bg-foreground-950/10' : 'text-white hover:bg-white/20'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <div className="flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/' ? 'text-foreground-950 bg-background-100' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                  location.pathname === `/category/${cat.slug}` ? 'text-foreground-950 bg-background-100' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/about' ? 'text-foreground-950 bg-background-100' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}